import { useEffect, useState } from "react";
import { ClientResponse } from "../AutoImportConfigurations/AddEditAutoImportModal/types/autoImportConfigContextTypes";
import { Client } from "@appTypes/clientTypes";

export function useClientsConfig(token: string) {
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    let isMounted = true;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_GATEWAY_BASE}/multitenancy/api/Clients/Clients`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch clients");
        return res.json();
      })
      .then((data: ClientResponse[]) => {
        if (!isMounted) return;
        const activeClients = data
          .filter((c) => c.isActive)
          .map((c) => ({
            formattedName: c.formattedName,
            clientValuePayload: { dtcNumber: c.dtcNumber, clientGuid: c.clientGuid },
          }));
        setClients(activeClients);
        setError(null);
      })
      .catch((e) => {
        if (!isMounted) return;
        setError(e.message);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [token]);

  return { clients, loading, error };
}